var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('template',{slot:"header"},[_vm._v("显示指标数值")]),_c('div',{staticStyle:{"width":"auto"}},[_c('div',{staticClass:"inner"},[_c('ve-line',_vm._b({attrs:{"data":_vm.chartData,"settings":_vm.chartSettings,"extend":_vm.extend}},'ve-line',_vm.pubSetting,false))],1)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }